import { toast } from '../../components/ui/toast';

const pad = (n: number) => String(n).padStart(2, '0');

export function fmtDate(iso: string): string {
  const d = new Date(iso);
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`;
}

export function fmtTime(iso: string): string {
  const d = new Date(iso);
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** "לפני 4 דק'", "היום 09:12", "אתמול 18:02", "03.10.2026". */
export function fmtRelative(iso: string | null, now = new Date()): string {
  if (!iso) return '';
  const d = new Date(iso);
  const mins = Math.round((now.getTime() - d.getTime()) / 60_000);
  if (mins < 1) return 'עכשיו';
  if (mins < 60) return `לפני ${mins} דק'`;
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  if (d.getTime() >= startOfToday) return `היום ${fmtTime(iso)}`;
  if (d.getTime() >= startOfToday - 86_400_000) return `אתמול ${fmtTime(iso)}`;
  return fmtDate(iso);
}

/** Two-letter avatar text, as in the mockup (`name.slice(0, 2)`). */
export function initials(name: string): string {
  return name.trim().slice(0, 2);
}

/** Only same-site paths, never back to the auth screens. */
export function safeNext(next: string | undefined): string {
  if (!next || !next.startsWith('/') || next.startsWith('//') || next.startsWith('/\\')) return '/';
  if (next.startsWith('/login') || next.startsWith('/mfa')) return '/';
  return next;
}

export function copyText(text: string, msg: string): void {
  const fail = () => toast('לא הצלחנו להעתיק. מסמנים את הטקסט ומעתיקים ידנית.', 'error');
  try {
    if (!navigator.clipboard) return fail();
    navigator.clipboard.writeText(text).then(() => toast(msg), fail);
  } catch {
    fail();
  }
}

export function downloadText(filename: string, text: string): void {
  const url = URL.createObjectURL(new Blob([text], { type: 'text/plain;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
